<template src="./Index.html">
</template>

<script>
    import DetailsView from "./details/Details";
    import AddView from "./actions/Add";


export default {
    components: {
        DetailsView,
        AddView
    },
    created() {
        this.getAll();
        this.$store.dispatch("lookups/getLookups");
        this.$store.dispatch("lookups/getLookups")

    },
    computed: {
        types() {
            return [{ value: 0, label: "الكل" }, ...this.$store.getters["lookups/getLookupByType"](this.$lookupTypes.ComplaintTypes)]
        },
        complaints() {
            return this.$store.state.complaints.complaints;
        },
        pageCount() {
            return Math.ceil(
                this.$store.state.complaints.totalItems / this.filters.pageSize
            );
        },
    },
    data() {
        return {
            response: null,
            dialog: false,


            items: [
                {
                    text: "الشكاوي والمقترحات ",
                },
                {
                    text: "قائمة الشكاوي والمقترحات",
                },
            ],
            totalItems: 0,
            subtitle: "قائمة الشكاوي والمقترحات",
          
            itemId: 0,
            view: 0,
            filters: {
                page: 1,
                pageSize: 10,
                content: null,
                typeId:0
            },
            headers: [
                //{
                //    text: "اسم الموظف",
                //    value: "createdBy",
                //    sortable: false,
                //    align: "start",
                //},
                {
                    text: "النوع ",
                    value: "type",
                    sortable: false,
                    align: "start",
                },
                {
                    text: "المحتوى",
                    value: "contents",
                    sortable: false,
                    align: "start",
                },
             
                { text: "تاريخ التسجيل", value: "createdOn", sortable: false },
                { text: "الحالة", value: "status", sortable: false },
                {
                    text: "الإجراءات",
                    value: "actions",
                    sortable: false,
                    align: "center",
                },
            ],
        };
    },
        methods: {
            addItem() {
                this.view = 1;
                this.items.push({ text: "إضافة شكوى/مقترح" });

            },
            showDetails(item) {
                this.itemId = item.complaintId;
                this.view = 3;
                this.items.push({ text: "عرض التفاصيل" });

            },

            showDialog(item) {
                this.itemId = item.complaintId
                this.dialog = true;
            },

            cancelDialog() {
                this.dialog = false;
                this.response = null;
                this.itemId = null;
            },
        getAll(page) {
            this.filters.page = page || 1;
            this.$store.dispatch("complaints/getAll", this.filters);
        },
        back() {
            this.view = 0;
            this.items = [
                {
                    text: "الشكاوي والمقترحات ",
                },
                {
                    text: "قائمة الشكاوي والمقترحات",
                },
            ];
        },
            reply() {
                let payload = {
                   response:this.response 
                    }
                this.$store.dispatch("complaints/reply", { id: this.itemId, payload: payload });
                this.cancelDialog();
        }
    },
};
</script>
